export default "__VITE_ASSET__Ccmu5IBs__"